module.exports = __webpack_public_path__ + "images/issue-type-repair.4d47e0eb3fd8bff2bf02ef763ac11588.png";